import qs from 'qs';
import { AxiosInstance } from 'axios';
import { WorkspaceKeyAvailabilityResource } from './resources';

export default class WorkspaceKey {
    private basePath = '/api/workspace-key';
    private http: AxiosInstance;

    constructor(http: AxiosInstance) {
        this.http = http;
    }

    // Get workspace key availability
    getAvailability = async (key: string): Promise<WorkspaceKeyAvailabilityResource> => {
        const query = qs.stringify({
            workspace_key: key,
        });

        const { data } = await this.http.get(`${this.basePath}/availability?${query}`);

        return data;
    };
}
